// extracted by mini-css-extract-plugin
export default {"action-area":"Card_action-area__J4YvJ","image":"Card_image__ML5s1","description":"Card_description__4p2Vl"};